import { makeBubbleAvatarUrl } from "~utils/url";

import { OrganizationItem } from "./OrganizationItem";
import { type Organization } from "./types";

interface OrganizationItemWithAvatarProps {
  organization: Organization;
  isSiteAdmin: boolean;
  showNoPublicPageIndicator?: boolean;
  showOpenInNewIcon?: boolean;
  showType?: boolean;
}

export const OrganizationItemWithAvatar = ({
  organization,
  isSiteAdmin,
  showNoPublicPageIndicator = false,
  showOpenInNewIcon = false,
  showType = true,
}: OrganizationItemWithAvatarProps) => {
  const avatarUrl = organization.bubbleId ? makeBubbleAvatarUrl(organization.bubbleId) : undefined;
  return (
    <OrganizationItem
      isSiteAdmin={isSiteAdmin}
      organization={{ ...organization, avatarUrl }}
      showNoPublicPageIndicator={showNoPublicPageIndicator}
      showOpenInNewIcon={showOpenInNewIcon}
      showType={showType}
    />
  );
};
